import * as React from "react";
import View from "views/logic/views/View";
import useViewType from "views/hooks/useViewType";
const IfDashboard = ({ children }) => {
  const viewType = useViewType();
  return viewType === View.Type.Dashboard ? /* @__PURE__ */ React.createElement(React.Fragment, null, children) : null;
};
export default IfDashboard;
